
import {combineLatest as observableCombineLatest, Observable} from 'rxjs';
import {ActivatedRoute, ActivatedRouteSnapshot, Params} from '@angular/router';
import {map} from 'rxjs/operators';

/**
 * By default, accessing the path params in Angular only returns the params at the current routing level. Children don't have access to their parents parameter
 *
 * There helper functions collect all params along the whole path and unify them
 */
export function collectRouteParams(route: ActivatedRoute): Observable<Params> {
  let allRoutes = route.pathFromRoot.map(route => route.params);
  return observableCombineLatest(allRoutes).pipe(map((allParams) => Object.assign({}, ...allParams)));
}

export function collectRouteParamsFromSnapshot(route: ActivatedRoute): Params {
    let allRoutes = route.pathFromRoot.map(route => route.snapshot.params);
    return Object.assign({}, ...allRoutes);
}

export function encodeReturnUrl(url: string): string {
    return encodeURIComponent(btoa(url));
}

export function decodeReturnUrl(encodedUrl: string): string {
    return atob(decodeURIComponent(encodedUrl));
}

export function extractReturnUrl(queryParams: Params): string {
    const returnUrlEncoded = queryParams['returnUrl'];
    if (!!returnUrlEncoded) {
        return decodeReturnUrl(returnUrlEncoded);
    } else {
        return '/';
    }
}
